<template>
   <component
      :is="componentMap[data.layout]"
      :key="data.key"
      v-bind="cleanData"
   />
</template>

<script setup lang="ts">
import omit from "lodash.omit";
const props = defineProps({
   data: Object,
});
const cleanData = computed(() => omit(props.data, ["key"]));

const componentMap = {
   StaticPageHero: resolveComponent("LazyStaticPageHero"),
   StaticPageNewsBlock: resolveComponent("LazyStaticPageNewsBlock"),
   StaticPageSimpleTextBlock: resolveComponent("LazyStaticPageSimpleTextBlock"),
   StaticPageFullWidthImage: resolveComponent("LazyStaticPageFullWidthImage"),
   StaticPageCenteredText: resolveComponent("LazyStaticPageCenteredText"),
   StaticPageFAQItem: resolveComponent("LazyStaticPageFAQItem"),
   FullWidthImage: resolveComponent("LazyStaticPageFullWidthImage"),
   credits_text: resolveComponent("LazyStaticPageCenteredText"),

   simple_content: resolveComponent("LazyStaticPageSimpleTextBlock"),
   explore_page_hero: resolveComponent("LazyStaticPageHero"),
   media_header: resolveComponent("LazyStaticPageFullWidthImage"),
};
</script>
